import { Outlet } from 'react-router'

import { SnippetsList } from '../../Settings/Snippets/SnippetsList'
import { LayoutStyles } from './LayoutStyles'

export const SnippetsLayout = () => {
    return <LayoutStyles leftNode={<SnippetsList selectedId={''} onSelect={() => {}} />} rightNode={<Outlet />} banner={false} />
}